import script from "./AppNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNavigation.vue?vue&type=script&setup=true&lang=js"

import "./AppNavigation.vue?vue&type=style&index=0&id=1912f636&lang=css"

const __exports__ = script;

export default __exports__